module.exports = {
  camera_icon: (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75033 0.166672L5.76783 2.33334H2.33366C1.14199 2.33334 0.166992 3.30834 0.166992 4.50001V17.5C0.166992 18.6917 1.14199 19.6667 2.33366 19.6667H19.667C20.8587 19.6667 21.8337 18.6917 21.8337 17.5V4.50001C21.8337 3.30834 20.8587 2.33334 19.667 2.33334H16.2328L14.2503 0.166672H7.75033ZM11.0003 16.4167C8.01033 16.4167 5.58366 13.99 5.58366 11C5.58366 8.01001 8.01033 5.58334 11.0003 5.58334C13.9903 5.58334 16.417 8.01001 16.417 11C16.417 13.99 13.9903 16.4167 11.0003 16.4167Z"
        fill="white"
      />
    </svg>
  ),

  center_align_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 20 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 2H19C19.2652 2 19.5196 1.89464 19.7071 1.70711C19.8946 1.51957 20 1.26522 20 1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5C4 5.26522 4.10536 5.51957 4.29289 5.70711C4.48043 5.89464 4.73478 6 5 6H15C15.2652 6 15.5196 5.89464 15.7071 5.70711C15.8946 5.51957 16 5.26522 16 5C16 4.73478 15.8946 4.48043 15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4H5ZM19 8H1C0.734784 8 0.48043 8.10536 0.292893 8.29289C0.105357 8.48043 0 8.73478 0 9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H19C19.2652 10 19.5196 9.89464 19.7071 9.70711C19.8946 9.51957 20 9.26522 20 9C20 8.73478 19.8946 8.48043 19.7071 8.29289C19.5196 8.10536 19.2652 8 19 8ZM15 12H5C4.73478 12 4.48043 12.1054 4.29289 12.2929C4.10536 12.4804 4 12.7348 4 13C4 13.2652 4.10536 13.5196 4.29289 13.7071C4.48043 13.8946 4.73478 14 5 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12Z" />
    </svg>
  ),
  left_align_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 20 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 2H19C19.2652 2 19.5196 1.89464 19.7071 1.70711C19.8946 1.51957 20 1.26522 20 1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM1 6H15C15.2652 6 15.5196 5.89464 15.7071 5.70711C15.8946 5.51957 16 5.26522 16 5C16 4.73478 15.8946 4.48043 15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6ZM19 8H1C0.734784 8 0.48043 8.10536 0.292893 8.29289C0.105357 8.48043 0 8.73478 0 9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H19C19.2652 10 19.5196 9.89464 19.7071 9.70711C19.8946 9.51957 20 9.26522 20 9C20 8.73478 19.8946 8.48043 19.7071 8.29289C19.5196 8.10536 19.2652 8 19 8ZM15 12H1C0.734784 12 0.48043 12.1054 0.292893 12.2929C0.105357 12.4804 0 12.7348 0 13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12Z" />
    </svg>
  ),
  right_align_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 20 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 2H19C19.2652 2 19.5196 1.89464 19.7071 1.70711C19.8946 1.51957 20 1.26522 20 1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM19 12H5C4.73478 12 4.48043 12.1054 4.29289 12.2929C4.10536 12.4804 4 12.7348 4 13C4 13.2652 4.10536 13.5196 4.29289 13.7071C4.48043 13.8946 4.73478 14 5 14H19C19.2652 14 19.5196 13.8946 19.7071 13.7071C19.8946 13.5196 20 13.2652 20 13C20 12.7348 19.8946 12.4804 19.7071 12.2929C19.5196 12.1054 19.2652 12 19 12ZM19 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5C4 5.26522 4.10536 5.51957 4.29289 5.70711C4.48043 5.89464 4.73478 6 5 6H19C19.2652 6 19.5196 5.89464 19.7071 5.70711C19.8946 5.51957 20 5.26522 20 5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4ZM19 8H1C0.734784 8 0.48043 8.10536 0.292893 8.29289C0.105357 8.48043 0 8.73478 0 9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H19C19.2652 10 19.5196 9.89464 19.7071 9.70711C19.8946 9.51957 20 9.26522 20 9C20 8.73478 19.8946 8.48043 19.7071 8.29289C19.5196 8.10536 19.2652 8 19 8Z" />
    </svg>
  ),
  undo_icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
      <g fill="currentColor" fillRule="evenodd">
        <path d="M5.138 13.026a.98.98 0 00.386 1.366 1.066 1.066 0 001.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026z"></path>
        <path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 100-2H6.503v-3A1 1 0 004.5 10z"></path>
      </g>
    </svg>
  ),
  redo_icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
      <g fill="currentColor" fillRule="evenodd">
        <path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 00.386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569z"></path>
        <path d="M17.497 10v3h-2.995a1 1 0 100 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 00-2.003 0z"></path>
      </g>
    </svg>
  ),
  bullet_list_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.71023 10.29C1.61513 10.199 1.50298 10.1276 1.38023 10.08C1.13677 9.97998 0.863694 9.97998 0.620232 10.08C0.497481 10.1276 0.385336 10.199 0.290233 10.29C0.199192 10.3851 0.127827 10.4972 0.0802325 10.62C0.00365307 10.8021 -0.0172696 11.0028 0.0201045 11.1968C0.0574787 11.3908 0.151475 11.5694 0.290233 11.71C0.387433 11.7983 0.499048 11.8694 0.620232 11.92C0.739933 11.9729 0.869362 12.0002 1.00023 12.0002C1.1311 12.0002 1.26053 11.9729 1.38023 11.92C1.50142 11.8694 1.61303 11.7983 1.71023 11.71C1.84899 11.5694 1.94299 11.3908 1.98036 11.1968C2.01773 11.0028 1.99681 10.8021 1.92023 10.62C1.87264 10.4972 1.80127 10.3851 1.71023 10.29ZM5.00023 2H19.0002C19.2654 2 19.5198 1.89464 19.7073 1.70711C19.8949 1.51957 20.0002 1.26522 20.0002 1C20.0002 0.734784 19.8949 0.48043 19.7073 0.292893C19.5198 0.105357 19.2654 0 19.0002 0H5.00023C4.73502 0 4.48066 0.105357 4.29313 0.292893C4.10559 0.48043 4.00023 0.734784 4.00023 1C4.00023 1.26522 4.10559 1.51957 4.29313 1.70711C4.48066 1.89464 4.73502 2 5.00023 2ZM1.71023 5.29C1.56961 5.15124 1.39104 5.05725 1.19705 5.01987C1.00306 4.9825 0.802343 5.00342 0.620232 5.08C0.499048 5.13064 0.387433 5.20167 0.290233 5.29C0.199192 5.3851 0.127827 5.49725 0.0802325 5.62C0.0273273 5.7397 0 5.86913 0 6C0 6.13087 0.0273273 6.2603 0.0802325 6.38C0.130874 6.50118 0.201902 6.6128 0.290233 6.71C0.387433 6.79833 0.499048 6.86936 0.620232 6.92C0.739933 6.97291 0.869362 7.00023 1.00023 7.00023C1.1311 7.00023 1.26053 6.97291 1.38023 6.92C1.50142 6.86936 1.61303 6.79833 1.71023 6.71C1.79856 6.6128 1.86959 6.50118 1.92023 6.38C1.97314 6.2603 2.00047 6.13087 2.00047 6C2.00047 5.86913 1.97314 5.7397 1.92023 5.62C1.87264 5.49725 1.80127 5.3851 1.71023 5.29ZM19.0002 5H5.00023C4.73502 5 4.48066 5.10536 4.29313 5.29289C4.10559 5.48043 4.00023 5.73478 4.00023 6C4.00023 6.26522 4.10559 6.51957 4.29313 6.70711C4.48066 6.89464 4.73502 7 5.00023 7H19.0002C19.2654 7 19.5198 6.89464 19.7073 6.70711C19.8949 6.51957 20.0002 6.26522 20.0002 6C20.0002 5.73478 19.8949 5.48043 19.7073 5.29289C19.5198 5.10536 19.2654 5 19.0002 5ZM1.71023 0.29C1.61513 0.198959 1.50298 0.127594 1.38023 0.0799999C1.19812 0.00342049 0.997409 -0.0175019 0.803419 0.0198722C0.609429 0.0572463 0.430856 0.151242 0.290233 0.29C0.201902 0.387201 0.130874 0.498815 0.0802325 0.62C0.0273273 0.7397 0 0.869129 0 1C0 1.13087 0.0273273 1.2603 0.0802325 1.38C0.130874 1.50119 0.201902 1.6128 0.290233 1.71C0.387433 1.79833 0.499048 1.86936 0.620232 1.92C0.802343 1.99658 1.00306 2.0175 1.19705 1.98013C1.39104 1.94275 1.56961 1.84876 1.71023 1.71C1.79856 1.6128 1.86959 1.50119 1.92023 1.38C1.97314 1.2603 2.00047 1.13087 2.00047 1C2.00047 0.869129 1.97314 0.7397 1.92023 0.62C1.86959 0.498815 1.79856 0.387201 1.71023 0.29ZM19.0002 10H5.00023C4.73502 10 4.48066 10.1054 4.29313 10.2929C4.10559 10.4804 4.00023 10.7348 4.00023 11C4.00023 11.2652 4.10559 11.5196 4.29313 11.7071C4.48066 11.8946 4.73502 12 5.00023 12H19.0002C19.2654 12 19.5198 11.8946 19.7073 11.7071C19.8949 11.5196 20.0002 11.2652 20.0002 11C20.0002 10.7348 19.8949 10.4804 19.7073 10.2929C19.5198 10.1054 19.2654 10 19.0002 10Z"
        fill="currentColor"
      />
    </svg>
  ),
  number_list_icon: (
    <svg
      width="15px"
      height="18px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18H21M4 14L4.94036 13.5298C5.57317 13.2134 6.33744 13.3374 6.83772 13.8377V13.8377C7.47963 14.4796 7.47963 15.5204 6.83772 16.1623L4 19H8M4.5 4.5H6V9.5M6 9.5H8M6 9.5H4M12 6H21M12 12H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  underline_icon: (
    <svg
      fill="currentColor"
      width="15px"
      height="18px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22,3a1,1,0,0,1-1,1H20v6A8,8,0,0,1,4,10V4H3A1,1,0,0,1,3,2H7A1,1,0,0,1,7,4H6v6a6,6,0,0,0,12,0V4H17a1,1,0,0,1,0-2h4A1,1,0,0,1,22,3Zm0,18a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H21A1,1,0,0,0,22,21Z" />
    </svg>
  ),
  strikethrugh_icon: (
    <svg
      fill="currentColor"
      width="15px"
      height="18px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13,15v5h3a1,1,0,0,1,0,2H8a1,1,0,0,1,0-2h3V15a1,1,0,0,1,2,0ZM3,11a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2H13V4h7V5a1,1,0,0,0,2,0V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V5A1,1,0,0,0,4,5V4h7v7Z" />
    </svg>
  ),
  code_icon: (
    <svg
      fill="currentColor"
      width="15px"
      height="18px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.293,11.293l4-4A1,1,0,1,1,6.707,8.707L3.414,12l3.293,3.293a1,1,0,1,1-1.414,1.414l-4-4A1,1,0,0,1,1.293,11.293Zm17.414-4a1,1,0,1,0-1.414,1.414L20.586,12l-3.293,3.293a1,1,0,1,0,1.414,1.414l4-4a1,1,0,0,0,0-1.414ZM13.039,4.726l-4,14a1,1,0,0,0,.686,1.236A1.053,1.053,0,0,0,10,20a1,1,0,0,0,.961-.726l4-14a1,1,0,1,0-1.922-.548Z" />
    </svg>
  ),
  text_color_icon: (
    <svg
      role="presentation"
      width="15"
      height="18"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M14 12.5h-4l-.874 2.186A.5.5 0 0 1 8.66 15H7.273a.5.5 0 0 1-.456-.705l4.05-9A.5.5 0 0 1 11.323 5h1.354a.5.5 0 0 1 .456.295l4.05 9a.5.5 0 0 1-.456.705h-1.388a.5.5 0 0 1-.465-.314L14 12.5zm-.6-1.5L12 7.5 10.6 11h2.8z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),

  text_icon: (
    <svg
      width="48"
      height="24"
      viewBox="0 0 48 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4444 12.1685C11.6089 12.0586 11.8022 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13C13 13.1978 12.9414 13.3911 12.8315 13.5556C12.7216 13.72 12.5654 13.8482 12.3827 13.9239C12.2 13.9996 11.9989 14.0194 11.8049 13.9808C11.6109 13.9422 11.4327 13.847 11.2929 13.7071C11.153 13.5673 11.0578 13.3891 11.0192 13.1951C10.9806 13.0011 11.0004 12.8 11.0761 12.6173C11.1518 12.4346 11.28 12.2784 11.4444 12.1685Z"
        fill="currentColor"
      />
      <path
        d="M35.4444 12.1685C35.6089 12.0586 35.8022 12 36 12C36.2652 12 36.5196 12.1054 36.7071 12.2929C36.8946 12.4804 37 12.7348 37 13C37 13.1978 36.9414 13.3911 36.8315 13.5556C36.7216 13.72 36.5654 13.8482 36.3827 13.9239C36.2 13.9996 35.9989 14.0194 35.8049 13.9808C35.6109 13.9422 35.4327 13.847 35.2929 13.7071C35.153 13.5673 35.0578 13.3891 35.0192 13.1951C34.9806 13.0011 35.0004 12.8 35.0761 12.6173C35.1518 12.4346 35.28 12.2784 35.4444 12.1685Z"
        fill="currentColor"
      />
      <path
        d="M17 2H7C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2V2ZM20 17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17V7C4 6.20435 4.31607 5.44129 4.87868 4.87868C5.44129 4.31607 6.20435 4 7 4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V17Z"
        fill="currentColor"
      />
      <path
        d="M41 2H31C29.6739 2 28.4021 2.52678 27.4645 3.46447C26.5268 4.40215 26 5.67392 26 7V17C26 18.3261 26.5268 19.5979 27.4645 20.5355C28.4021 21.4732 29.6739 22 31 22H41C42.3261 22 43.5979 21.4732 44.5355 20.5355C45.4732 19.5979 46 18.3261 46 17V7C46 5.67392 45.4732 4.40215 44.5355 3.46447C43.5979 2.52678 42.3261 2 41 2V2ZM44 17C44 17.7956 43.6839 18.5587 43.1213 19.1213C42.5587 19.6839 41.7956 20 41 20H31C30.2044 20 29.4413 19.6839 28.8787 19.1213C28.3161 18.5587 28 17.7956 28 17V7C28 6.20435 28.3161 5.44129 28.8787 4.87868C29.4413 4.31607 30.2044 4 31 4H41C41.7956 4 42.5587 4.31607 43.1213 4.87868C43.6839 5.44129 44 6.20435 44 7V17Z"
        fill="currentColor"
      />
    </svg>
  ),
  dropdown_icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0002 9.16994C16.8128 8.98369 16.5594 8.87915 16.2952 8.87915C16.031 8.87915 15.7776 8.98369 15.5902 9.16994L12.0002 12.7099L8.46019 9.16994C8.27283 8.98369 8.01938 8.87915 7.75519 8.87915C7.49101 8.87915 7.23756 8.98369 7.05019 9.16994C6.95646 9.26291 6.88207 9.37351 6.8313 9.49537C6.78053 9.61723 6.75439 9.74793 6.75439 9.87994C6.75439 10.012 6.78053 10.1427 6.8313 10.2645C6.88207 10.3864 6.95646 10.497 7.05019 10.5899L11.2902 14.8299C11.3832 14.9237 11.4938 14.9981 11.6156 15.0488C11.7375 15.0996 11.8682 15.1257 12.0002 15.1257C12.1322 15.1257 12.2629 15.0996 12.3848 15.0488C12.5066 14.9981 12.6172 14.9237 12.7102 14.8299L17.0002 10.5899C17.0939 10.497 17.1683 10.3864 17.2191 10.2645C17.2699 10.1427 17.296 10.012 17.296 9.87994C17.296 9.74793 17.2699 9.61723 17.2191 9.49537C17.1683 9.37351 17.0939 9.26291 17.0002 9.16994Z"
        fill="currentColor"
      />
    </svg>
  ),
  listcard_icon: (
    <svg
      width="45"
      height="24"
      viewBox="0 0 45 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 16H26C25.7348 16 25.4804 16.1054 25.2929 16.2929C25.1054 16.4804 25 16.7348 25 17C25 17.2652 25.1054 17.5196 25.2929 17.7071C25.4804 17.8946 25.7348 18 26 18H36C36.2652 18 36.5196 17.8946 36.7071 17.7071C36.8946 17.5196 37 17.2652 37 17C37 16.7348 36.8946 16.4804 36.7071 16.2929C36.5196 16.1054 36.2652 16 36 16ZM26 8H44C44.2652 8 44.5196 7.89464 44.7071 7.70711C44.8946 7.51957 45 7.26522 45 7C45 6.73478 44.8946 6.48043 44.7071 6.29289C44.5196 6.10536 44.2652 6 44 6H35H26C25.7348 6 25.4804 6.10536 25.2929 6.29289C25.1054 6.48043 25 6.73478 25 7C25 7.26522 25.1054 7.51957 25.2929 7.70711C25.4804 7.89464 25.7348 8 26 8ZM44 11H26C25.7348 11 25.4804 11.1054 25.2929 11.2929C25.1054 11.4804 25 11.7348 25 12C25 12.2652 25.1054 12.5196 25.2929 12.7071C25.4804 12.8946 25.7348 13 26 13H44C44.2652 13 44.5196 12.8946 44.7071 12.7071C44.8946 12.5196 45 12.2652 45 12C45 11.7348 44.8946 11.4804 44.7071 11.2929C44.5196 11.1054 44.2652 11 44 11Z"
        fill="currentColor"
      />
      <path
        d="M17 2H7C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2V2ZM20 17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17V7C4 6.20435 4.31607 5.44129 4.87868 4.87868C5.44129 4.31607 6.20435 4 7 4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V17Z"
        fill="currentColor"
      />
    </svg>
  ),

  link_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-[18px]"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
      />
    </svg>
  ),

  image_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-[18px]"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
      />
    </svg>
  ),

  subscript_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.3546 42.9106C41.3546 43.5123 40.8669 44 40.2652 44H31.7102C30.9645 44 30.36 43.3955 30.36 42.6498C30.36 42.3119 30.4866 41.9864 30.7149 41.7373L35.8067 36.1836C36.5929 35.3076 37.1507 34.5776 37.4801 33.9937C37.817 33.4022 37.9855 32.8107 37.9855 32.2192C37.9855 31.4406 37.7646 30.8117 37.3229 30.3325C36.8886 29.8534 36.3009 29.6138 35.5597 29.6138C34.6762 29.6138 33.9912 29.8833 33.5045 30.4224C33.2803 30.6707 33.1077 30.9612 32.9868 31.2938C32.7293 32.002 32.1636 32.6348 31.41 32.6348C30.6564 32.6348 30.0239 32.0151 30.1981 31.2819C30.3101 30.8104 30.4839 30.3667 30.7193 29.9507C31.176 29.1496 31.8237 28.5282 32.6622 28.0864C33.5082 27.6447 34.4815 27.4238 35.5821 27.4238C37.1694 27.4238 38.4197 27.8244 39.3331 28.6255C40.254 29.4191 40.7145 30.5197 40.7145 31.9272C40.7145 32.7433 40.4824 33.6006 40.0182 34.499C39.5615 35.39 38.809 36.4045 37.7608 37.5425L33.7628 41.8213H40.2652C40.8669 41.8213 41.3546 42.309 41.3546 42.9106Z"
        fill="black"
      />
      <path
        d="M7 2.5697L27 37.2107"
        stroke="black"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M27 2.5697L7 37.2107"
        stroke="black"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  ),

  superscript_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.8673 19.4868C42.8673 20.0885 42.3796 20.5762 41.7779 20.5762H33.2229C32.4772 20.5762 31.8727 19.9717 31.8727 19.226C31.8727 18.8881 31.9993 18.5625 32.2276 18.3135L37.3194 12.7598C38.1056 11.8838 38.6634 11.1538 38.9928 10.5698C39.3297 9.97835 39.4981 9.38688 39.4981 8.79541C39.4981 8.01676 39.2773 7.38786 38.8356 6.90869C38.4013 6.42952 37.8136 6.18994 37.0724 6.18994C36.1889 6.18994 35.5038 6.45947 35.0172 6.99854C34.793 7.24689 34.6204 7.53736 34.4995 7.86995C34.242 8.57819 33.6763 9.21094 32.9227 9.21094C32.1691 9.21094 31.5366 8.59126 31.7108 7.85808C31.8228 7.38657 31.9966 6.94283 32.232 6.52686C32.6887 5.72575 33.3364 5.10433 34.1749 4.6626C35.0209 4.22087 35.9942 4 37.0948 4C38.6821 4 39.9324 4.40055 40.8458 5.20166C41.7667 5.99528 42.2272 7.09587 42.2272 8.50342C42.2272 9.3195 41.9951 10.1768 41.5309 11.0752C41.0742 11.9661 40.3217 12.9806 39.2735 14.1187L35.2755 18.3975H41.7779C42.3796 18.3975 42.8673 18.8852 42.8673 19.4868Z"
        fill="black"
      />
      <path
        d="M6 4L29.0247 43.88"
        stroke="black"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M29.0249 4L6.00015 43.88"
        stroke="black"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  ),

  task_icon: (
    <svg width="24" height="22" viewBox="0 0 24 24" role="presentation">
      <path
        d="M7.5 6h9A1.5 1.5 0 0118 7.5v9a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 16.5v-9A1.5 1.5 0 017.5 6zm3.072 8.838l.143.154a.5.5 0 00.769-.042l.13-.175 3.733-5.045a.8.8 0 00-.11-1.064.665.665 0 00-.984.118l-3.243 4.387-1.315-1.422a.663.663 0 00-.99 0 .801.801 0 000 1.07l1.867 2.019z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),

  code_block_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 7C2 5.89543 2.89543 5 4 5H44C45.1046 5 46 5.89543 46 7V43C46 44.1046 45.1046 45 44 45H4C2.89543 45 2 44.1046 2 43V7ZM4 12H44V42C44 42.5523 43.5523 43 43 43H5C4.44771 43 4 42.5523 4 42V12ZM36 8.5C36 9.05228 35.5523 9.5 35 9.5C34.4477 9.5 34 9.05228 34 8.5C34 7.94772 34.4477 7.5 35 7.5C35.5523 7.5 36 7.94772 36 8.5ZM38 9.5C38.5523 9.5 39 9.05228 39 8.5C39 7.94772 38.5523 7.5 38 7.5C37.4477 7.5 37 7.94772 37 8.5C37 9.05228 37.4477 9.5 38 9.5ZM41 9.5C41.5523 9.5 42 9.05228 42 8.5C42 7.94772 41.5523 7.5 41 7.5C40.4477 7.5 40 7.94772 40 8.5C40 9.05228 40.4477 9.5 41 9.5Z"
        fill="black"
      />
      <path
        d="M19 24L11 27.5L19 31"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29 24L37 27.5L29 31"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.5 19.5L21 35.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  ),

  table_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
      />
    </svg>
  ),

  two_by_two_table_icon: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0ZM8 16H2V10H8V16ZM8 8H2V2H8V8ZM16 16H10V10H16V16ZM16 8H10V2H16V8Z"
        fill="currentColor"
      />
    </svg>
  ),

  add_column_icon: (
    <svg
      width="15px"
      height="18px"
      viewBox="4 5 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 20H20V4H4V20ZM5.5 18.5V16.5H8.5V18.5H5.5ZM10 18.5V5.5H18.5V18.5H10ZM8.5 5.5V8.01959H5.5V5.5H8.5ZM5.5 9.51959H8.5V11.5H5.5V9.51959ZM5.5 13H8.5V15H5.5V13Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 12.5V15H15V12.5H17.5001V11H15V8.5H13.5V11H11V12.5H13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),

  add_new_row: (
    <svg
      width="15px"
      height="18px"
      viewBox="4 5 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 4H20V20H4V4ZM5.5 5.5V8H8.5V5.5H5.5ZM10 5.5V8H13.9999L14 5.5H10ZM15.5 5.5L15.4999 8H18.5V5.5H15.5ZM18.5 9.5H5.5V18.5H18.5V9.5Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5 13.5V11H13V13.5H15.5001V15H13V17.5H11.5V15H9V13.5H11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  delete_table_icon: (
    <svg
      fill="currentColor"
      width="15px"
      height="18px"
      viewBox=" 0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <path
          d="M9.414 8l2.122-2.121-1.415-1.415L8 6.586 5.879 4.464 4.464 5.88 6.586 8l-2.122 2.121 1.415 1.415L8 9.414l2.121 2.122 1.415-1.415L9.414 8zM0 16h16V0H0v16zm2-2V2h12v12H2z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  delete_row_icon: (
    <svg
      width="15px"
      height="18px"
      viewBox="4 5 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20 4H4V20H8V18.5H5.5V13H18.5V18.5H16V20H20V4ZM5.5 8V5.5H8.5V8H5.5ZM10 8V5.5H14L13.9999 8H10ZM15.4999 8L15.5 5.5H18.5V8H15.4999ZM15.4999 9.5H18.5V11.5H15.4998L15.4999 9.5ZM8.5 11.5H5.5V9.5H8.5V11.5ZM10 11.5V9.5H13.9999L13.9998 11.5H10Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 18.7804L13.2197 20.0001L14.2803 18.9395L13.0606 17.7197L14.2802 16.5001L13.2196 15.4395L12 16.6591L10.7803 15.4395L9.71968 16.5001L10.9393 17.7197L9.71967 18.9394L10.7803 20.0001L12 18.7804Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  delete_column_icon: (
    <svg
      fill="currentColor"
      width="15px"
      height="18px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <path
          d="M1800 1740c0 33-27 60-60 60h-420v-300h-120v300H720v-300H600v300H180c-33.12 0-60-27-60-60V180c0-33 26.88-60 60-60h420v300h120V120h480v300h120V120h420c33 0 60 27 60 60v1560ZM1740 0H180C80.76 0 0 80.76 0 180v1560c0 99.24 80.76 180 180 180h1560c99.24 0 180-80.76 180-180V180c0-99.24-80.76-180-180-180Zm-305.16 654.84-169.68-169.68L960 790.32 654.84 485.16 485.16 654.84 790.32 960l-305.16 305.16 169.68 169.68L960 1129.68l305.16 305.16 169.68-169.68L1129.68 960l305.16-305.16Z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  circle_plus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-7 h-7"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  delete_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
      />
    </svg>
  ),
  delete_icon2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-auto h-auto"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
      />
    </svg>
  ),
  edit_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
      />
    </svg>
  ),
  cog_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  ),
  external_link: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </svg>
  ),
  globe_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
      />
    </svg>
  ),
  command_line: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"
      />
    </svg>
  ),
  cloud_upload: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4201 8.22002C17.8091 6.81602 16.7546 5.65109 15.4182 4.90374C14.0818 4.15639 12.5372 3.86785 11.0211 4.08233C9.50501 4.2968 8.10106 5.00247 7.02439 6.09119C5.94772 7.17991 5.25772 8.59163 5.06013 10.11C4.10672 10.3383 3.27036 10.9089 2.70987 11.7132C2.14939 12.5176 1.90382 13.4997 2.0198 14.4732C2.13578 15.4467 2.60523 16.3437 3.339 16.9939C4.07277 17.644 5.01976 18.0021 6.00013 18C6.26535 18 6.5197 17.8947 6.70724 17.7071C6.89478 17.5196 7.00013 17.2652 7.00013 17C7.00013 16.7348 6.89478 16.4804 6.70724 16.2929C6.5197 16.1054 6.26535 16 6.00013 16C5.4697 16 4.96099 15.7893 4.58592 15.4142C4.21085 15.0392 4.00013 14.5304 4.00013 14C4.00013 13.4696 4.21085 12.9609 4.58592 12.5858C4.96099 12.2107 5.4697 12 6.00013 12C6.26535 12 6.5197 11.8947 6.70724 11.7071C6.89478 11.5196 7.00013 11.2652 7.00013 11C7.00269 9.8173 7.42442 8.67377 8.1904 7.7726C8.95639 6.87143 10.017 6.27097 11.1839 6.07789C12.3507 5.88481 13.5483 6.11162 14.5637 6.71803C15.5791 7.32443 16.3467 8.27116 16.7301 9.39002C16.7873 9.56186 16.89 9.71495 17.0274 9.83295C17.1648 9.95095 17.3316 10.0294 17.5101 10.06C18.1762 10.1859 18.78 10.5336 19.2232 11.0466C19.6663 11.5595 19.9227 12.2074 19.9505 12.8847C19.9784 13.5619 19.776 14.2287 19.3764 14.7762C18.9769 15.3238 18.4036 15.7199 17.7501 15.9C17.4929 15.9663 17.2725 16.1321 17.1375 16.3609C17.0024 16.5897 16.9638 16.8628 17.0301 17.12C17.0964 17.3773 17.2622 17.5977 17.491 17.7327C17.7198 17.8677 17.9929 17.9063 18.2501 17.84C19.3025 17.5619 20.2354 16.948 20.9071 16.0915C21.5789 15.235 21.9527 14.1826 21.972 13.0943C21.9912 12.0059 21.6547 10.9411 21.0137 10.0613C20.3727 9.18161 19.462 8.53512 18.4201 8.22002ZM12.7101 10.29C12.615 10.199 12.5029 10.1276 12.3801 10.08C12.1367 9.98 11.8636 9.98 11.6201 10.08C11.4974 10.1276 11.3852 10.199 11.2901 10.29L8.29013 13.29C8.10183 13.4783 7.99604 13.7337 7.99604 14C7.99604 14.2663 8.10183 14.5217 8.29013 14.71C8.47844 14.8983 8.73383 15.0041 9.00013 15.0041C9.26644 15.0041 9.52183 14.8983 9.71013 14.71L11.0001 13.41V19C11.0001 19.2652 11.1055 19.5196 11.293 19.7071C11.4806 19.8947 11.7349 20 12.0001 20C12.2654 20 12.5197 19.8947 12.7072 19.7071C12.8948 19.5196 13.0001 19.2652 13.0001 19V13.41L14.2901 14.71C14.3831 14.8037 14.4937 14.8781 14.6156 14.9289C14.7374 14.9797 14.8681 15.0058 15.0001 15.0058C15.1321 15.0058 15.2629 14.9797 15.3847 14.9289C15.5066 14.8781 15.6172 14.8037 15.7101 14.71C15.8039 14.6171 15.8783 14.5065 15.929 14.3846C15.9798 14.2627 16.0059 14.132 16.0059 14C16.0059 13.868 15.9798 13.7373 15.929 13.6154C15.8783 13.4936 15.8039 13.383 15.7101 13.29L12.7101 10.29Z"
        fill="#34d399"
      />
    </svg>
  ),
  copy_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
      />
    </svg>
  ),
  loading_icon: (
    <svg
      className="   animate-spin  h-5 w-5 text-current"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  ),
  flex_box: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM8 20H4V4H8V20ZM20 20H10V13H20V20ZM20 11H10V4H20V11Z"
        fill="currentColor"
      />
    </svg>
  ),
  list_box: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 20H4V10H20V20ZM20 8H4V4H20V8Z"
        fill="currentCOlor"
      />
    </svg>
  ),
  flex_right: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM14 20H4V13H14V20ZM14 11H4V4H14V11ZM20 20H16V4H20V20Z"
        fill="currentCOlor"
      />
    </svg>
  ),
  bulb: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2715 35.7275L14.0999 32.8991"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M24 5V9"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14.1011 13.1011L11.2726 10.2726M36.7285 35.7285L33.9001 32.9001L36.7285 35.7285Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M42 23H38M10 23H6H10Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M11.2722 35.7273L14.1006 32.8989M33.8997 13.1003L36.7281 10.2719L33.8997 13.1003Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M20 35.6038H28M20 35.6038V39L22.2222 41C22.2222 42.1046 23.0182 43 24 43C24.9818 43 25.7778 42.1046 25.7778 41L28 39V35.6038H20ZM20 35.6038V32.2077C16.4732 30.686 14 27.1362 14 23C14 17.4772 18.4094 13 23.8486 13C29.2878 13 33.6971 17.4772 33.6971 23C33.6971 27.0168 31.3647 30.4805 28 32.0708V35.6038H20Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  ),

  left_arrow_from_left: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9999 11H5.4099L7.7099 8.71C7.80313 8.61676 7.8771 8.50607 7.92756 8.38425C7.97802 8.26243 8.00399 8.13186 8.00399 8C8.00399 7.86814 7.97802 7.73757 7.92756 7.61575C7.8771 7.49393 7.80313 7.38324 7.7099 7.29C7.61666 7.19676 7.50597 7.1228 7.38415 7.07234C7.26232 7.02188 7.13176 6.99591 6.9999 6.99591C6.86804 6.99591 6.73747 7.02188 6.61565 7.07234C6.49383 7.1228 6.38313 7.19676 6.2899 7.29L2.2899 11.29C2.19886 11.3851 2.12749 11.4972 2.0799 11.62C1.97988 11.8635 1.97988 12.1365 2.0799 12.38C2.12749 12.5028 2.19886 12.6149 2.2899 12.71L6.2899 16.71C6.38286 16.8037 6.49346 16.8781 6.61532 16.9289C6.73718 16.9797 6.86788 17.0058 6.9999 17.0058C7.13191 17.0058 7.26261 16.9797 7.38447 16.9289C7.50633 16.8781 7.61693 16.8037 7.7099 16.71C7.80363 16.617 7.87802 16.5064 7.92879 16.3846C7.97956 16.2627 8.00569 16.132 8.00569 16C8.00569 15.868 7.97956 15.7373 7.92879 15.6154C7.87802 15.4936 7.80363 15.383 7.7099 15.29L5.4099 13H16.9999C17.2651 13 17.5195 12.8946 17.707 12.7071C17.8945 12.5196 17.9999 12.2652 17.9999 12C17.9999 11.7348 17.8945 11.4804 17.707 11.2929C17.5195 11.1054 17.2651 11 16.9999 11ZM20.9999 4C20.7347 4 20.4803 4.10536 20.2928 4.29289C20.1053 4.48043 19.9999 4.73478 19.9999 5V19C19.9999 19.2652 20.1053 19.5196 20.2928 19.7071C20.4803 19.8946 20.7347 20 20.9999 20C21.2651 20 21.5195 19.8946 21.707 19.7071C21.8945 19.5196 21.9999 19.2652 21.9999 19V5C21.9999 4.73478 21.8945 4.48043 21.707 4.29289C21.5195 4.10536 21.2651 4 20.9999 4Z"
        fill="currentColor"
      />
    </svg>
  ),
  left_arrow_to_left: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11H9.41L11.71 8.71C11.8032 8.61676 11.8772 8.50607 11.9277 8.38425C11.9781 8.26243 12.0041 8.13186 12.0041 8C12.0041 7.86814 11.9781 7.73757 11.9277 7.61575C11.8772 7.49393 11.8032 7.38324 11.71 7.29C11.6168 7.19676 11.5061 7.1228 11.3842 7.07234C11.2624 7.02188 11.1319 6.99591 11 6.99591C10.8681 6.99591 10.7376 7.02188 10.6158 7.07234C10.4939 7.1228 10.3832 7.19676 10.29 7.29L6.29 11.29C6.19896 11.3851 6.12759 11.4972 6.08 11.62C5.97998 11.8635 5.97998 12.1365 6.08 12.38C6.12759 12.5028 6.19896 12.6149 6.29 12.71L10.29 16.71C10.383 16.8037 10.4936 16.8781 10.6154 16.9289C10.7373 16.9797 10.868 17.0058 11 17.0058C11.132 17.0058 11.2627 16.9797 11.3846 16.9289C11.5064 16.8781 11.617 16.8037 11.71 16.71C11.8037 16.617 11.8781 16.5064 11.9289 16.3846C11.9797 16.2627 12.0058 16.132 12.0058 16C12.0058 15.868 11.9797 15.7373 11.9289 15.6154C11.8781 15.4936 11.8037 15.383 11.71 15.29L9.41 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21C3.26522 21 3.51957 20.8946 3.70711 20.7071C3.89464 20.5196 4 20.2652 4 20V4C4 3.73478 3.89464 3.48043 3.70711 3.29289C3.51957 3.10536 3.26522 3 3 3Z"
        fill="currentColor"
      />
    </svg>
  ),
  arrow_from_top: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.29 16.29L13 18.59V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6C11.7348 6 11.4804 6.10536 11.2929 6.29289C11.1054 6.48043 11 6.73478 11 7V18.59L8.71 16.29C8.5217 16.1017 8.2663 15.9959 8 15.9959C7.7337 15.9959 7.4783 16.1017 7.29 16.29C7.1017 16.4783 6.99591 16.7337 6.99591 17C6.99591 17.2663 7.1017 17.5217 7.29 17.71L11.29 21.71C11.3851 21.801 11.4972 21.8724 11.62 21.92C11.7397 21.9729 11.8691 22.0002 12 22.0002C12.1309 22.0002 12.2603 21.9729 12.38 21.92C12.5028 21.8724 12.6149 21.801 12.71 21.71L16.71 17.71C16.8983 17.5217 17.0041 17.2663 17.0041 17C17.0041 16.7337 16.8983 16.4783 16.71 16.29C16.6168 16.1968 16.5061 16.1228 16.3842 16.0723C16.2624 16.0219 16.1319 15.9959 16 15.9959C15.7337 15.9959 15.4783 16.1017 15.29 16.29ZM19 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3C4 3.26522 4.10536 3.51957 4.29289 3.70711C4.48043 3.89464 4.73478 4 5 4H19C19.2652 4 19.5196 3.89464 19.7071 3.70711C19.8946 3.51957 20 3.26522 20 3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2Z"
        fill="currentColor"
      />
    </svg>
  ),
  arrow_to_top: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.71 6.29C12.6149 6.19896 12.5028 6.12759 12.38 6.08C12.1365 5.97998 11.8635 5.97998 11.62 6.08C11.4972 6.12759 11.3851 6.19896 11.29 6.29L7.29 10.29C7.19676 10.3832 7.1228 10.4939 7.07234 10.6158C7.02188 10.7376 6.99591 10.8681 6.99591 11C6.99591 11.1319 7.02188 11.2624 7.07234 11.3842C7.1228 11.5061 7.19676 11.6168 7.29 11.71C7.38324 11.8032 7.49393 11.8772 7.61575 11.9277C7.73757 11.9781 7.86814 12.0041 8 12.0041C8.13186 12.0041 8.26243 11.9781 8.38425 11.9277C8.50607 11.8772 8.61676 11.8032 8.71 11.71L11 9.41V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V9.41L15.29 11.71C15.383 11.8037 15.4936 11.8781 15.6154 11.9289C15.7373 11.9797 15.868 12.0058 16 12.0058C16.132 12.0058 16.2627 11.9797 16.3846 11.9289C16.5064 11.8781 16.617 11.8037 16.71 11.71C16.8037 11.617 16.8781 11.5064 16.9289 11.3846C16.9797 11.2627 17.0058 11.132 17.0058 11C17.0058 10.868 16.9797 10.7373 16.9289 10.6154C16.8781 10.4936 16.8037 10.383 16.71 10.29L12.71 6.29ZM19 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3C4 3.26522 4.10536 3.51957 4.29289 3.70711C4.48043 3.89464 4.73478 4 5 4H19C19.2652 4 19.5196 3.89464 19.7071 3.70711C19.8946 3.51957 20 3.26522 20 3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2Z"
        fill="currentColor"
      />
    </svg>
  ),
  padding_bottom: (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20L15 20C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19C16 18.7348 15.8946 18.4804 15.7071 18.2929C15.5196 18.1054 15.2652 18 15 18L1 18C0.734784 18 0.48043 18.1054 0.292893 18.2929C0.105357 18.4804 0 18.7348 0 19ZM7.62 0.0799999C7.49725 0.127594 7.3851 0.19896 7.29 0.290001L3.29 4.29C3.19676 4.38324 3.1228 4.49393 3.07234 4.61575C3.02188 4.73757 2.99591 4.86814 2.99591 5C2.99591 5.2663 3.1017 5.5217 3.29 5.71C3.4783 5.8983 3.7337 6.00409 4 6.00409C4.2663 6.00409 4.5217 5.8983 4.71 5.71L7 3.41L7 15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15L9 3.41L11.29 5.71C11.383 5.80373 11.4936 5.87812 11.6154 5.92889C11.7373 5.97966 11.868 6.0058 12 6.0058C12.132 6.0058 12.2627 5.97966 12.3846 5.92889C12.5064 5.87812 12.617 5.80373 12.71 5.71C12.8037 5.61704 12.8781 5.50644 12.9289 5.38458C12.9797 5.26272 13.0058 5.13201 13.0058 5C13.0058 4.86799 12.9797 4.73728 12.9289 4.61542C12.8781 4.49356 12.8037 4.38296 12.71 4.29L8.71 0.290001C8.6149 0.19896 8.50275 0.127594 8.38 0.0799999C8.13654 -0.0200181 7.86346 -0.0200181 7.62 0.0799999Z"
        fill="currentColor"
      />
    </svg>
  ),
  padding_top: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22H19C19.2652 22 19.5196 21.8946 19.7071 21.7071C19.8946 21.5196 20 21.2652 20 21C20 20.7348 19.8946 20.4804 19.7071 20.2929C19.5196 20.1054 19.2652 20 19 20H5C4.73478 20 4.48043 20.1054 4.29289 20.2929C4.10536 20.4804 4 20.7348 4 21ZM11.62 2.08C11.4972 2.12759 11.3851 2.19896 11.29 2.29L7.29 6.29C7.19676 6.38324 7.1228 6.49393 7.07234 6.61575C7.02188 6.73757 6.99591 6.86814 6.99591 7C6.99591 7.2663 7.1017 7.5217 7.29 7.71C7.4783 7.8983 7.7337 8.00409 8 8.00409C8.2663 8.00409 8.5217 7.8983 8.71 7.71L11 5.41L11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17L13 5.41L15.29 7.71C15.383 7.80373 15.4936 7.87812 15.6154 7.92889C15.7373 7.97966 15.868 8.0058 16 8.0058C16.132 8.0058 16.2627 7.97966 16.3846 7.92889C16.5064 7.87812 16.617 7.80373 16.71 7.71C16.8037 7.61704 16.8781 7.50644 16.9289 7.38458C16.9797 7.26272 17.0058 7.13201 17.0058 7C17.0058 6.86799 16.9797 6.73728 16.9289 6.61542C16.8781 6.49356 16.8037 6.38296 16.71 6.29L12.71 2.29C12.6149 2.19896 12.5028 2.12759 12.38 2.08C12.1365 1.97998 11.8635 1.97998 11.62 2.08Z"
        fill="currentColor"
      />
    </svg>
  ),
  left_padding: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.86166 5.15833C3.59649 5.16296 3.34401 5.27274 3.15978 5.46352C2.97554 5.6543 2.87464 5.91045 2.87927 6.17563L3.1236 20.1735C3.12823 20.4387 3.23801 20.6912 3.42879 20.8754C3.61957 21.0596 3.87573 21.1605 4.1409 21.1559C4.40608 21.1513 4.65856 21.0415 4.84279 20.8507C5.02702 20.6599 5.12793 20.4038 5.1233 20.1386L4.87896 6.14072C4.87434 5.87555 4.76456 5.62307 4.57377 5.43884C4.38299 5.2546 4.12684 5.1537 3.86166 5.15833ZM22.9118 12.447C22.862 12.3251 22.7887 12.2142 22.696 12.1207L18.6268 8.1911C18.532 8.09951 18.42 8.02749 18.2973 7.97916C18.1747 7.93084 18.0437 7.90715 17.9118 7.90945C17.6456 7.91409 17.392 8.02432 17.2071 8.21589C17.0221 8.40745 16.9208 8.66465 16.9254 8.93091C16.9301 9.19717 17.0403 9.45068 17.2318 9.63567L19.5715 11.8852L7.98322 12.0875C7.71805 12.0921 7.46557 12.2019 7.28133 12.3926C7.0971 12.5834 6.9962 12.8396 7.00083 13.1048C7.00546 13.3699 7.11524 13.6224 7.30602 13.8066C7.4968 13.9909 7.75295 14.0918 8.01813 14.0871L19.6064 13.8849L17.3467 16.2147C17.2546 16.3093 17.1821 16.4211 17.1335 16.5439C17.0849 16.6666 17.061 16.7977 17.0633 16.9297C17.0656 17.0617 17.094 17.1919 17.1469 17.3129C17.1998 17.4339 17.2761 17.5431 17.3715 17.6344C17.466 17.7265 17.5779 17.799 17.7007 17.8476C17.8234 17.8963 17.9545 17.9201 18.0865 17.9178C18.2185 17.9155 18.3487 17.8871 18.4697 17.8342C18.5906 17.7813 18.6999 17.705 18.7912 17.6097L22.7208 13.5405C22.8102 13.4438 22.8796 13.3304 22.925 13.2069C23.0208 12.9617 23.016 12.6886 22.9118 12.447Z"
        fill="currentColor"
      />
    </svg>
  ),
  right_padding: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 20C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4C20.7348 4 20.4804 4.10536 20.2929 4.29289C20.1054 4.48043 20 4.73478 20 5V19C20 19.2652 20.1054 19.5196 20.2929 19.7071C20.4804 19.8946 20.7348 20 21 20ZM2.08 12.38C2.12759 12.5028 2.19896 12.6149 2.29 12.71L6.29 16.71C6.38324 16.8032 6.49393 16.8772 6.61575 16.9277C6.73757 16.9781 6.86814 17.0041 7 17.0041C7.2663 17.0041 7.5217 16.8983 7.71 16.71C7.8983 16.5217 8.00409 16.2663 8.00409 16C8.00409 15.7337 7.8983 15.4783 7.71 15.29L5.41 13L17 13C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11L5.41 11L7.71 8.71C7.80373 8.61704 7.87812 8.50644 7.92889 8.38458C7.97966 8.26272 8.0058 8.13201 8.0058 8C8.0058 7.86799 7.97966 7.73728 7.92889 7.61542C7.87812 7.49356 7.80373 7.38296 7.71 7.29C7.61704 7.19627 7.50644 7.12188 7.38458 7.07111C7.26272 7.02034 7.13201 6.9942 7 6.9942C6.86799 6.9942 6.73728 7.02034 6.61542 7.07111C6.49356 7.12188 6.38296 7.19627 6.29 7.29L2.29 11.29C2.19896 11.3851 2.12759 11.4972 2.08 11.62C1.97998 11.8635 1.97998 12.1365 2.08 12.38Z"
        fill="currentColor"
      />
    </svg>
  ),

  reset: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"
      />
    </svg>
  ),
  tradly_logo: (
    <svg
      width="full"
      height="full"
      viewBox="0 0 126 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63 0C97.7939 0 126 28.2061 126 63C126 97.7939 97.7939 126 63 126C28.2061 126 0 97.7939 0 63C0 28.2061 28.2061 0 63 0Z"
        fill="url(#paint0_linear)"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63 119C93.9279 119 119 93.9279 119 63C119 32.0721 93.9279 7 63 7C32.0721 7 7 32.0721 7 63C7 93.9279 32.0721 119 63 119Z"
        stroke="white"
        stroke-width="1.4"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63 105C86.196 105 105 86.196 105 63C105 39.804 86.196 21 63 21C39.804 21 21 39.804 21 63C21 86.196 39.804 105 63 105Z"
        stroke="white"
        stroke-width="1.4"
      />
      <path
        d="M108.282 44.2442C105.799 38.2551 102.162 32.8652 97.6482 28.3518C88.7809 19.4845 76.5309 14 63 14C49.469 14 37.219 19.4845 28.3517 28.3518C23.8383 32.8652 20.2012 38.2551 17.7178 44.2442"
        stroke="white"
        stroke-width="15.4"
        stroke-linecap="round"
      />
      <path
        d="M63.0001 14.0001V111.222"
        stroke="white"
        stroke-width="15.4"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="126"
          y1="0"
          x2="126"
          y2="126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BDBC0" />
          <stop offset="1" stop-color="#13B58C" />
        </linearGradient>
      </defs>
    </svg>
  ),
  collapse: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
      />
    </svg>
  ),
  expand: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"
      />
    </svg>
  ),
  close_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),
  plus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-10 h-10"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  ),
  mobile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
      />
    </svg>
  ),
  tab: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"
      />
    </svg>
  ),
  computer: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"
      />
    </svg>
  ),
  qr_code: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"
      />
    </svg>
  ),

  sticky_icon: (
    <svg
      data-tradly-icon="PositionStickyIcon"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 10.5C20.484 10.5 21.4409 10.1775 22.2241 9.58181C23.0073 8.98614 23.5737 8.15018 23.8365 7.20193C24.0993 6.25368 24.0441 5.24542 23.6793 4.33156C23.3144 3.41769 22.6601 2.6486 21.8165 2.14206C20.9729 1.63552 19.9865 1.41945 19.0084 1.52694C18.0303 1.63443 17.1144 2.05955 16.401 2.73721C15.6875 3.41487 15.2158 4.30771 15.0581 5.27899C14.9005 6.25028 15.0655 7.24646 15.528 8.11501L10.323 13.32C10.2009 13.4418 10.1039 13.5865 10.0377 13.7458C9.97153 13.9051 9.93734 14.0759 9.93713 14.2484C9.93693 14.4209 9.9707 14.5918 10.0365 14.7512C10.1023 14.9107 10.1989 15.0556 10.3208 15.1778C10.4426 15.2999 10.5873 15.3968 10.7466 15.463C10.9059 15.5292 11.0767 15.5634 11.2492 15.5636C11.4217 15.5638 11.5925 15.5301 11.752 15.4642C11.9115 15.3984 12.0564 15.3018 12.1785 15.18L17.3835 9.97201C18.0135 10.3095 18.7335 10.5 19.4985 10.5H19.5Z"
        fill="currentColor"
      ></path>
      <path
        opacity="0.6"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3025 3H1.5V21H22.5V11.1975C22.035 11.4675 21.5325 11.6745 21 11.8125V19.5H3V7.5H13.689C13.2976 5.9773 13.5183 4.36183 14.304 3H14.3025ZM10.5 4.5V6H7.5V4.5H10.5ZM6 4.5V6H3V4.5H6Z"
        fill="currentColor"
      ></path>
    </svg>
  ),

  absolute_icon: (
    <svg
      data-tradly-icon="PositionAbsoluteIcon"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 3H22.5V9H21V3ZM13.5 4.5V3H1.5V12H3V4.5H13.5ZM10.5 19.5H1.5V21H10.5V19.5Z"
        fill="currentColor"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 3H15V4.5H16.5V9H18V4.5H19.5V3H16.5ZM3 13.5H1.5V18H3V16.5H10.5V15H3V13.5ZM22.5 10.5H12V21H22.5V10.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  relative_icon: (
    <svg
      data-tradly-icon="PositionRelativeIcon"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 3H13.5V4.5H16.5V9H18V4.5H21V3H16.5ZM3 12H1.5V19.5H3V16.5H10.5V15H3V12ZM22.5 10.5H12V21H22.5V10.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  fixed_icon: (
    <svg
      data-tradly-icon="PositionFixedIcon"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5 3H21V6H19.5V7.5H21V9H22.5V3ZM15 7.5V6H13.5V3H1.5V12H3V7.5H15ZM10.5 6V4.5H7.5V6H10.5ZM6 6V4.5H3V6H6ZM1.5 19.5H10.5V21H1.5V19.5Z"
        fill="currentColor"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 3H15V4.5H16.5V9H18V4.5H19.5V3H16.5ZM3 13.5H1.5V18H3V16.5H10.5V15H3V13.5ZM22.5 10.5H12V21H22.5V10.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  static_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-[14px] h-[14px]"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),
  prev_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4   "
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.75 19.5L8.25 12l7.5-7.5"
      />
    </svg>
  ),
  next_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.25 4.5l7.5 7.5-7.5 7.5"
      />
    </svg>
  ),

  question_mark: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.83834 14.1056 10.6796 13.3353 11.1354C13.1385 11.2518 12.9761 11.3789 12.8703 11.5036C12.7675 11.6246 12.75 11.7036 12.75 11.75V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V11.75C11.25 11.2441 11.4715 10.8336 11.7266 10.533C11.9786 10.236 12.2929 10.0092 12.5715 9.84439C12.9044 9.64739 13.125 9.28655 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
        fill="#a3a3a3"
      />
    </svg>
  ),
  arrow_down: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
      />
    </svg>
  ),
  arrow_up: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
      />
    </svg>
  ),
  flex_icon: (
    <svg
      data-tradly-icon="DisplayFlexIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5 12V4C7.5 3.44772 7.05228 3 6.5 3H4C3.44772 3 3 3.44772 3 4V12C3 12.5523 3.44772 13 4 13H6.5C7.05228 13 7.5 12.5523 7.5 12ZM8.5 4V12C8.5 12.5523 8.94772 13 9.5 13H12C12.5523 13 13 12.5523 13 12V4C13 3.44772 12.5523 3 12 3H9.5C8.94772 3 8.5 3.44772 8.5 4ZM6.5 4L4 4L4 12H6.5V4ZM12 4H9.5V12H12V4Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  block_icon: (
    <svg
      data-tradly-icon="DisplayBlockIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 3H13V2H3V3ZM3 14H13V13H3V14Z"
        fill="currentColor"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 6H4V10H12V6ZM4 5C3.44772 5 3 5.44772 3 6V10C3 10.5523 3.44772 11 4 11H12C12.5523 11 13 10.5523 13 10V6C13 5.44772 12.5523 5 12 5H4Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  hide_icon: (
    <svg
      data-tradly-icon="HideIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.705 11.4122L13.6464 14.3536L14.3535 13.6465L2.35353 1.64648L1.64642 2.35359L4.38807 5.09524C3.39352 5.76124 2.59317 6.69436 2.08962 7.79152C2.02885 7.92392 2.02885 8.07624 2.08962 8.20865C3.11613 10.4452 5.37595 12 7.99998 12C8.96537 12 9.88147 11.7896 10.705 11.4122ZM9.9407 10.6479L5.11149 5.81865C4.25762 6.3466 3.55885 7.10172 3.09959 8.00007C4.01046 9.78177 5.86344 11 7.99998 11C8.68305 11 9.33713 10.8755 9.9407 10.6479Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.9104 8.20856C13.5777 8.93353 13.1153 9.58688 12.553 10.1389L11.846 9.43184C12.2702 9.01685 12.6276 8.5337 12.9004 8C11.9895 6.21831 10.1366 5.00004 8.00002 5.00004C7.81171 5.00004 7.62559 5.0095 7.44213 5.02798L6.57164 4.15749C7.03124 4.05443 7.50926 4.00004 8.00002 4.00004C10.6241 4.00004 12.8839 5.55491 13.9104 7.79143C13.9712 7.92383 13.9712 8.07616 13.9104 8.20856Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  align_start: (
    <svg
      data-tradly-icon="AlignItemsStartRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 2H15V3H11V7.5C11 7.77614 10.7761 8 10.5 8L9.5 8C9.22386 8 9 7.77614 9 7.5V3L8 3L8 11.5C8 11.7761 7.77614 12 7.5 12H6.5C6.22386 12 6 11.7761 6 11.5L6 3L2 3V2Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  align_center: (
    <svg
      data-tradly-icon="AlignItemsCenterRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7V2.5C8 2.22386 7.77614 2 7.5 2H6.5C6.22386 2 6 2.22386 6 2.5V7L2 7V8L15 8V7H11V4.5C11 4.22386 10.7761 4 10.5 4L9.5 4C9.22386 4 9 4.22386 9 4.5V7H8Z"
        fill="currentColor"
      ></path>
      <path
        d="M8 9V13.5C8 13.7761 7.77614 14 7.5 14H6.5C6.22386 14 6 13.7761 6 13.5V9H8Z"
        fill="currentColor"
      ></path>
      <path
        d="M10.5 12C10.7761 12 11 11.7761 11 11.5V9H9V11.5C9 11.7761 9.22386 12 9.5 12H10.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  align_end: (
    <svg
      data-tradly-icon="AlignItemsEndRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13L8 4.5C8 4.22386 7.77614 4 7.5 4H6.5C6.22386 4 6 4.22386 6 4.5L6 13L2 13V14L15 14V13H11V8.5C11 8.22386 10.7761 8 10.5 8L9.5 8C9.22386 8 9 8.22386 9 8.5V13H8Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  align_stretch: (
    <svg
      data-tradly-icon="AlignItemsStretchRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 3L2 3V2H15V3L11 3V13L15 13V14L2 14V13H6L6 3ZM8 3L9 3L9 13H8L8 3Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  align_baseline: (
    <svg
      data-tradly-icon="AlignItemsBaselineRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 7V3.5C8 3.22386 7.77614 3 7.5 3H5.5C5.22386 3 5 3.22386 5 3.5L5 7H2V8H5V13.5C5 13.7761 5.22386 14 5.5 14H7.5C7.77614 14 8 13.7761 8 13.5V8H9V10.5C9 10.7761 9.22386 11 9.5 11H11.5C11.7761 11 12 10.7761 12 10.5V8L15 8V7L12 7V3.5C12 3.22386 11.7761 3 11.5 3H9.5C9.22386 3 9 3.22386 9 3.5V7H8ZM6 4V7H7V4L6 4ZM10 7H11V4L10 4V7Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  justify_start: (
    <svg
      data-tradly-icon="JustifyContentStartRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 14V11H4.5C4.77614 11 5 10.7761 5 10.5V4.5C5 4.22386 4.77614 4 4.5 4H3V1H2V14H3Z"
        fill="currentColor"
      ></path>
      <path
        d="M6 4.5C6 4.22386 6.22386 4 6.5 4H7.5C7.77614 4 8 4.22386 8 4.5V10.5C8 10.7761 7.77614 11 7.5 11H6.5C6.22386 11 6 10.7761 6 10.5V4.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  justify_center: (
    <svg
      data-tradly-icon="JustifyContentCenterRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14V11H5.5C5.22386 11 5 10.7761 5 10.5V4.5C5 4.22386 5.22386 4 5.5 4H7V1H8V14H7Z"
        fill="currentColor"
      ></path>
      <path
        d="M11 4.5C11 4.22386 10.7761 4 10.5 4H9.5C9.22386 4 9 4.22386 9 4.5V10.5C9 10.7761 9.22386 11 9.5 11H10.5C10.7761 11 11 10.7761 11 10.5V4.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  justify_end: (
    <svg
      data-tradly-icon="JustifyContentEndRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14V11H11.5C11.2239 11 11 10.7761 11 10.5V4.5C11 4.22386 11.2239 4 11.5 4H13V1H14V14H13Z"
        fill="currentColor"
      ></path>
      <path
        d="M10 4.5C10 4.22386 9.77614 4 9.5 4H8.5C8.22386 4 8 4.22386 8 4.5V10.5C8 10.7761 8.22386 11 8.5 11H9.5C9.77614 11 10 10.7761 10 10.5V4.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  justify_space_between: (
    <svg
      data-tradly-icon="JustifyContentSpaceBetweenRowReverseIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4L14 1L15 1L15 14L14 14L14 11L12.5 11C12.2239 11 12 10.7761 12 10.5L12 4.5C12 4.22386 12.2239 4 12.5 4L14 4Z"
        fill="currentColor"
      ></path>
      <path
        d="M2 14L2 0.999999L3 0.999999L3 4L4.5 4C4.77614 4 5 4.22386 5 4.5L5 10.5C5 10.7761 4.77614 11 4.5 11L3 11L3 14L2 14Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  space_around: (
    <svg
      data-tradly-icon="JustifyContentSpaceAroundRowIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 14V1H3V14H2Z" fill="currentColor"></path>
      <path
        d="M4.5 4C4.22386 4 4 4.22386 4 4.5L4 10.5C4 10.7761 4.22386 11 4.5 11H5.5C5.77614 11 6 10.7761 6 10.5L6 4.5C6 4.22386 5.77614 4 5.5 4L4.5 4Z"
        fill="currentColor"
      ></path>
      <path
        d="M11.5 11C11.2239 11 11 10.7761 11 10.5V4.5C11 4.22386 11.2239 4 11.5 4L12.5 4C12.7761 4 13 4.22386 13 4.5V10.5C13 10.7761 12.7761 11 12.5 11H11.5Z"
        fill="currentColor"
      ></path>
      <path d="M14 14V1H15V14H14Z" fill="currentColor"></path>
    </svg>
  ),

  text_justify: (
    <svg
      data-tradly-icon="TextAlignJustifyIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 3H15V4H1V3Z" fill="currentColor"></path>
      <path d="M1 7H15V8H1V7Z" fill="currentColor"></path>
      <path d="M15 11H1V12H15V11Z" fill="currentColor"></path>
    </svg>
  ),
  text_right: (
    <svg
      data-tradly-icon="TextAlignRightIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 3H15V4H1V3Z" fill="currentColor"></path>
      <path d="M7 7H15V8H7V7Z" fill="currentColor"></path>
      <path d="M15 11H5V12H15V11Z" fill="currentColor"></path>
    </svg>
  ),
  text_center: (
    <svg
      data-tradly-icon="TextAlignCenterIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 3H15V4H1V3Z" fill="currentColor"></path>
      <path d="M4 7H12V8H4V7Z" fill="currentColor"></path>
      <path d="M13 11H3V12H13V11Z" fill="currentColor"></path>
    </svg>
  ),
  text_left: (
    <svg
      data-tradly-icon="TextAlignLeftIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 3H15V4H1V3ZM1 7H9V8H1V7ZM11 11H1V12H11V11Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  border_all_corner: (
    <svg
      data-tradly-icon="BorderRadiusSingleIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.5C2.5 3.84315 3.84315 2.5 5.5 2.5H10.5C12.1569 2.5 13.5 3.84315 13.5 5.5V10.5C13.5 12.1569 12.1569 13.5 10.5 13.5H5.5C3.84315 13.5 2.5 12.1569 2.5 10.5V5.5Z"
        stroke="currentColor"
      ></path>
    </svg>
  ),
  border_separate_corner: (
    <svg
      data-tradly-icon="BorderRadiusAllIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.4"
        x="5"
        y="5"
        width="6"
        height="6"
        fill="currentColor"
      ></rect>
      <path
        d="M4.5 2C3.11929 2 2 3.11929 2 4.5V7H3V4.5C3 3.67157 3.67157 3 4.5 3H7V2H4.5Z"
        fill="currentColor"
      ></path>
      <path
        d="M9 2V3H11.5C12.3284 3 13 3.67157 13 4.5V7H14V4.5C14 3.11929 12.8807 2 11.5 2H9Z"
        fill="currentColor"
      ></path>
      <path
        d="M14 9H13V11.5C13 12.3284 12.3284 13 11.5 13H9V14H11.5C12.8807 14 14 12.8807 14 11.5V9Z"
        fill="currentColor"
      ></path>
      <path
        d="M7 14V13H4.5C3.67157 13 3 12.3284 3 11.5V9H2V11.5C2 12.8807 3.11929 14 4.5 14H7Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  border_radius_top_left: (
    <svg
      data-tradly-icon="BorderRadiusTopLeftIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path d="M14 14V9H13V13H9V14H14Z" fill="currentColor"></path>
        <path d="M7 14V13H3V9H2V14H7Z" fill="currentColor"></path>
        <path
          d="M2 7H3V6.5C3 4.567 4.567 3 6.5 3H7V2H6.5C4.01472 2 2 4.01472 2 6.5V7Z"
          fill="currentColor"
        ></path>
        <path d="M9 2V3H13V7H14V2H9Z" fill="currentColor"></path>
      </g>
      <path
        d="M2.5 7V6.5C2.5 4.29086 4.29086 2.5 6.5 2.5H7"
        stroke="currentColor"
      ></path>
    </svg>
  ),
  border_radius_top_right: (
    <svg
      data-tradly-icon="BorderRadiusTopRightIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path d="M2 14V9H3V13H7V14H2Z" fill="currentColor"></path>
        <path d="M9 14V13H13V9H14V14H9Z" fill="currentColor"></path>
        <path
          d="M14 7H13V6.5C13 4.567 11.433 3 9.5 3H9V2H9.5C11.9853 2 14 4.01472 14 6.5V7Z"
          fill="currentColor"
        ></path>
        <path d="M7 2V3H3V7H2V2H7Z" fill="currentColor"></path>
      </g>
      <path
        d="M13.5 7V6.5C13.5 4.29086 11.7091 2.5 9.5 2.5H9"
        stroke="currentColor"
      ></path>
    </svg>
  ),
  border_radius_bottom_left: (
    <svg
      data-tradly-icon="BorderRadiusBottomLeftIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 13.5H10.5C6.08172 13.5 2.5 9.91828 2.5 5.5V2"
        stroke="currentColor"
      ></path>
      <path
        opacity="0.4"
        d="M5 5.5C5 8.53757 7.46243 11 10.5 11H14V2H5V5.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  border_radius_bottom_right: (
    <svg
      data-tradly-icon="BorderRadiusBottomRightIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 13.5H5.5C9.91828 13.5 13.5 9.91828 13.5 5.5V2"
        stroke="currentColor"
      ></path>
      <path
        opacity="0.4"
        d="M11 5.5C11 8.53757 8.53757 11 5.5 11H2V2H11V5.5Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
};
